<script setup lang="ts">

import {defineProps} from "vue";
import router from "@/router";
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useMapStore } from '@/stores/mapStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  x: number,
  y: number,
}>();

const gotoMap = () => {
  router.push('/map/galaxy/' + props.x + '/' + props.y);
  const mapStore = useMapStore();
  mapStore.gotoX = props.x
  mapStore.gotoY = props.y
  mapStore.toolTipVisible = false

  const gameStore = useGameStore();
  gameStore.hideModel()
}

</script>

<template>
    <GenericIcon :tooltip="t('map.tooltips.openOnMap')" type="location" :title="'' + props.x + ' x ' + props.y " class="cursor-pointer" @click="gotoMap"></GenericIcon>
</template>

<style scoped lang="scss">

</style>